import { apiResourceUrl } from "@ploy-lib/core";
import { BaseResource } from "./BaseResource";
class CompetitionResource extends BaseResource {
    pk() {
        return this.id.toString();
    }
}
CompetitionResource.urlRoot = apiResourceUrl("competitions");
export { CompetitionResource };
class CompetitionResultResource extends BaseResource {
    pk() {
        return `${this.competitionId}/results/${this.position}`;
    }
}
CompetitionResultResource.urlRoot = apiResourceUrl("competitions/{competitionId}/results");
export { CompetitionResultResource };
//# sourceMappingURL=CompetitionResource.js.map